import React, { useState, useEffect, useRef } from "react";
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import { SlideInWithScroll } from "../utils/animations/slideInWithScroll";

export default function TechnologySlider(props) {
  const { items, classes } = props.data;
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const [clientWidth, setclientWidth] = useState(0);
  const [isMobile, setisMobile] = useState(false);
  const ref = useRef();
  let triggers = [0.89, 0.87, 0.85, 0.83, 0.81, 0.79, 0.77, 0.75, 0.73, 0.71, 0.69, 0.67, 0.65, 0.63, 0.61, 0.59];

  if (clientWidth <= 1681) {
    triggers.map((t) => t += 0.2);
  }

  const setValues = () => {
    setisMobile(window.innerWidth <= 767);
    setElementTop(ref.current.offsetTop);
    setClientHeight(window.innerHeight);
    setclientWidth(window.innerWidth);
  };

  useEffect(() => {
    if (!ref.current) return;

    props.isLoaded && setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 7,
    autoplaySpeed: 2000,
    autoplay: true,
    rows: 2,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      }
    ]
  };

  return (
    <>
      <div ref={ref} className={`technology-list-section section-gap ${classes}`} id={props.id ? props.id : ''} onLoad={setValues}>
        <div className="container">
          <ul className="technology-list">
            {isMobile && <> <Slider {...settings}>
              {items.map((item, index) => {
                const jsx = (<motion.li key={index}>
                  <div>
                    <i>{item.image}</i><p>{item.name}</p>
                  </div>
                </motion.li>);
                return <SlideInWithScroll elementTop={elementTop} clientHeight={clientHeight} children={jsx} triggerPoints={[triggers[index], triggers[index + 2]]} length={25} key={index} />;
              })}
            </Slider></>}
            {!isMobile && <>
              {items.map((item, index) => {
                const jsx = (<motion.li key={index}>
                  <div>
                    <i>{item.image}</i><p>{item.name}</p>
                  </div>
                </motion.li>);
                return <SlideInWithScroll elementTop={elementTop} clientHeight={clientHeight} children={jsx} triggerPoints={[triggers[index], triggers[index + 2]]} length={25} key={index} />;
              })}
            </>}

          </ul>
        </div>
      </div>
    </>
  );
}